<!--
   V 0.2.0 - 2024-12-18
     - added the prop: formatControl this so that I could determine the format
       of the picker

   V 0.1.0 - 2022-07-14

   TO DO:
     I could not get this component to work without a watch on the ['value'] prop,
     my instinct is that is should be possible withouth a watch on ['value']

 -->
 <template>
  <div>
    <v-menu
      class="elevation-2 px-6"
      ref="ref_menu"
      v-model="datePickerMenu"
      :close-on-content-click="false"
      :return-value.sync="day"
      transition="scale-transition"
      offset-y
      min-width="auto"
    >
      <template v-slot:activator="{ on, attrs }">
        <v-text-field
          :value="computedDateFormattedDatefns"
          class="elevation-2 px-6"
          label="Picker in menu"
          prepend-icon="mdi-calendar"
          readonly
          v-bind="attrs"
          v-on="on"
        ></v-text-field>
      </template>
      <v-date-picker
        v-model="day"
        @click:date="
          datePickerMenu = false;
          $refs.ref_menu.save(day);
          updateDate();
        "
        no-title
        scrollable
      >
        <v-spacer></v-spacer>
        <v-btn text color="primary" @click="datePicker1Menu = false">
          Cancel
        </v-btn>
      </v-date-picker>
    </v-menu>
  </div>
</template>

<script>
import { format, parseISO } from 'date-fns'

export default {
  name: 'DatePick',
  props: {
    /**
     * Prop to define the desired format for the displayed date
     */
    formatControl: {
      type: String,
      default: 'EEEE, MMMM do yyyy' // Default format
    },

    /**
     *  just using prop ["value"] did not work for the watcherm it
     *  reqyures default and type
     */
    value: {
      default: format(parseISO(new Date().toISOString()), 'yyyy-MM-dd'),
      type: String
    }
  },

  watch: {
    value: {
      /*  NB! immediate: true

          This s necessary as otherwise the default for day stands
          and not that carried by prop value on startip

          immediate : trigger the callback immediately on watcher creation.
          old value will be undefined on the first call.

      */
      immediate: true,
      /**
       *   Not necessary for this as it is simple object
       *
       *   deep: force deep traversal of the source if it is an object or an array,
       *   so that the callback fires on deep mutations. See Deep Watchers.
       *
       */
      // deep: true,
      handler (valNew, valOld) {
        if (valNew !== valOld) {
          this.day = this.value
        }
      }
    }
  },

  methods: {
    /*
     * Ensure thats the v-model is updated with the correct date
     */
    updateDate () {
      this.$emit('input', this.day)
    }
  },

  computed: {
    /**
     *  This is where formatting for the way date picker looks is set.
     */
    computedDateFormattedDatefns () {
      // https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#string-arguments
      // return this.day ? format(parseISO(this.day), "EEEE, MMMM do yyyy") : "";
      return this.day ? format(parseISO(this.day), this.formatControl) : ''
    }
  },
  /**
   *  NB: The component's data section requires a function because
   *
   *  A component’s data option must be a function, so that each instance can maintain an
   *   independent copy of the returned data object:
   *
   *      data: function () {
   *        return {
   *          count: 0
   *        }
   *      }
   *
   *  If Vue didn’t have this rule, clicking on one button would affect the data of all
   *  other instances.
   *
   *
   */
  data: function () {
    return {
      // https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#string-arguments
      day: format(parseISO(new Date().toISOString()), 'yyyy-MM-dd'),
      datePickerMenu: false
    }
  }
}
</script>
